"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const debug = new debug_1.default('@wingspan/proms');
class Proms {
    constructor(params) {
        this.batchSize = params && typeof params.batchSize === 'number'
            ? params.batchSize : 5;
        this.counter = 0;
        this.total = 0;
        this.promises = [];
        this.results = [];
    }
    run(promise) {
        this.promises.push(promise);
        if (this.promises.length >= this.batchSize) {
            return this.awaitproms();
        }
        return Promise.resolve('ok');
    }
    awaitproms() {
        return __awaiter(this, void 0, void 0, function* () {
            const numProms = this.promises.length;
            debug(`${this.counter}: awaiting on ${numProms} promises...`);
            const results = yield Promise.all(this.promises);
            this.promises = [];
            this.total += numProms;
            debug(`${this.counter}: ${this.total} promises have been invoked`);
            this.counter++;
            this.results.push(...results);
            return this.results;
        });
    }
}
exports.Proms = Proms;
exports.runProms = (arr, func, batchSize) => __awaiter(void 0, void 0, void 0, function* () {
    const proms = new Proms({
        batchSize,
    });
    for (const obj of arr) {
        yield proms.run(func(obj));
    }
    return proms.awaitproms();
});
exports.runBatches = (func, arr, batchSize, collectResults = false) => __awaiter(void 0, void 0, void 0, function* () {
    let batch = [];
    const results = [];
    for (const _idx in arr) {
        const idx = parseInt(_idx);
        const doc = arr[idx];
        batch.push(doc);
        if (batch.length >= batchSize || idx === arr.length - 1) {
            if (collectResults) {
                results.push(...yield func(batch));
            }
            else {
                yield func(batch);
            }
            batch = [];
        }
    }
    return collectResults ? results : undefined;
});
//# sourceMappingURL=proms.js.map